import { GameAction, GameActionTypes, favoriteError } from "./Game";
import { Dispatch } from "redux";
import { addToFavorite as apiAddToFavorite } from "@blacknut/javascript-sdk/dist/api/addToFavorite";
const addToFavoriteRequest = (id: string): GameAction => ({
  type: GameActionTypes.ADD_TO_FAVORITE_REQUEST,
  id,
});

export const addToFavoriteSuccess = (id: string): GameAction => ({
  type: GameActionTypes.ADD_TO_FAVORITE_SUCCESS,
  id,
});

export const addToFavorite = (id: string) => {
  return (dispatch: Dispatch<GameAction>) => {
    return new Promise<void>((resolve, reject) => {
      dispatch(addToFavoriteRequest(id));
      apiAddToFavorite(id).subscribe({
        next: () => {
          dispatch(addToFavoriteSuccess(id));
          resolve();
        },
        error: (error) => {
          dispatch(favoriteError(id, error));
          reject(error);
        },
      });
    });
  };
};
